import { render, staticRenderFns } from "./PoslovniPartneri.vue?vue&type=template&id=7d360429&scoped=true&"
import script from "./PoslovniPartneri.vue?vue&type=script&lang=ts&"
export * from "./PoslovniPartneri.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d360429",
  null
  
)

export default component.exports